export const convertParToSumRadiation = ({ par }) => {
  return ((par * 24 * 0.219) / 10000) * (60 * 60 * 24)
}
